import { Outlet } from "react-router-dom";
import classes from "./ChatScreenLayout.jsx.module.css";
import clsx from "clsx";
import RightSidebar from "./RightSidebar/RightSidebar";
import Navbar from "./Navbar/Navbar";

import { useAppContext } from "ContextProvider/ContextProvider";
const ChatScreenLayout = ({
  showSelectAiDropdown,
  setShowSelectAiDropdown,
  setSelectedModel,
  selectedModel,
  models,
  aiCharacters,
  isLoggedIn,
  userData,
}) => {
  const { leftSidebar, setLeftSidebar, rightSidebar, setRightSidebar } =
    useAppContext();

  // allow Enter to submit

  return (
    <main
      className={clsx(
        classes.wrapper,
        "wrapper2",
        !leftSidebar && classes.noLeftSidebarWrapper,
        !rightSidebar && classes.noRightSidebarWrapper
      )}
    >
      <Navbar
        setShowSelectAiDropdown={setShowSelectAiDropdown}
        showSelectAiDropdown={showSelectAiDropdown}
        setSidebar={setLeftSidebar}
        sidebar={leftSidebar}
        rightSidebar={rightSidebar}
        setRightSidebar={setRightSidebar}
        setSelectedModel={setSelectedModel}
        aiCharacters={aiCharacters}
        models={models}
        selectedModel={selectedModel}
        userData={userData}
      />

      <div
        className={clsx(
          classes.container,
          "container2",
          !leftSidebar && classes.noLeftSidebar,
          !rightSidebar && classes.noRightSidbar
        )}
      >
        <Outlet />
      </div>
      <RightSidebar setSidebar={setRightSidebar} sidebar={rightSidebar} />
    </main>
  );
};
export default ChatScreenLayout;
